import React, { useEffect, useState } from "react";
import { SelectUi } from "../../ui/SelectUi";
import { Form } from "antd";
import { getAlmacenesEmpleadoSelect } from "../../../actions/cotizacion";

export const AlmacenEmpleadoSelect = ({ empleado, ...props }) => {
  const form = Form.useFormInstance();
  const { setFieldValue } = form;
  const [almacenes, setAlmacenes] = useState([]);

  useEffect(() => {
    const OnLoadAlmacenes = async (empleado) => {
      const datos = await getAlmacenesEmpleadoSelect(empleado);
      setAlmacenes(datos);
      setFieldValue("cantidad_almacenes", datos?.length);
      if (datos?.length === 1) {
        setFieldValue("establecimiento", datos[0]?.value);
      }
    };
    OnLoadAlmacenes(empleado);
  }, [empleado]);

  return <SelectUi data={almacenes} {...props} />;
};
